export default __webpack_public_path__ + "static/1880-69e42290cea034c54f15d51fc02579e6.gif";